import React from 'react';
import DualAxisChart from '../../charts/DualAxisChart'
import parse from 'date-fns/parse'
import {useTranslation} from "react-i18next";

const ConsentByDayChart = ({data}) => {
  const { t } = useTranslation();

  const dataToPoint = accessor => elt => ([
    parse(elt.date, 'yyyy-MM-dd', new Date()).getTime(),
    elt[accessor]
  ])

  const dataToPointRate = (numerator, divider) => elt => ([
    parse(elt.date, 'yyyy-MM-dd', new Date()).getTime(),
    100 * elt[numerator]/elt[divider]
  ])


  const dataToChartSeries = (data) => {
    const dailyCmpPresented = data.map(dataToPoint("dailyCmpPresented"))
    const dailyAverageDisplayRank = data.map(dataToPoint("dailyAverageDisplayRank"))
    const dailyConsents = data.map(dataToPoint("dailyConsents"))
    const dailyConsentRate = data.map(dataToPointRate("dailyConsents", "devices"))

    return [
      {
        "name": t("cmp.analytics.metrics.dailyCmpPresented"),
        "data": dailyCmpPresented,
        "color": "#B2382B",
        "visible": true,
        "type": "areaspline"
      },
      {
        "name": t("cmp.analytics.metrics.dailyAverageDisplayRank"),
        "data": dailyAverageDisplayRank,
        "color": "#FED3CF",
        "visible": false,
        "type": "areaspline"
      },
      {
        "name": t("cmp.analytics.metrics.dailyConsents"),
        "data": dailyConsents,
        "color": "#FF513C",
        "visible": true,
        "type": "areaspline"
      },
      {
        "name": t("cmp.analytics.metrics.dailyConsentRate"),
        "data": dailyConsentRate,
        "color": "#DDDDDD",
        "yAxis": 1,
        "type": "spline",
        "visible": true,
        "tooltip": {
          "valueDecimals": 2,
          "valueSuffix": "%"
        }
      }
    ]
  }
  const chartData = dataToChartSeries(data);
  return (<DualAxisChart legendOptions={{clickable: true}} series={chartData}/>)
}

export default ConsentByDayChart
